import { render, staticRenderFns } from "./multigroup.vue?vue&type=template&id=cf6d1060"
import script from "./multigroup.vue?vue&type=script&lang=js"
export * from "./multigroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src881454487/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf6d1060')) {
      api.createRecord('cf6d1060', component.options)
    } else {
      api.reload('cf6d1060', component.options)
    }
    module.hot.accept("./multigroup.vue?vue&type=template&id=cf6d1060", function () {
      api.rerender('cf6d1060', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/reports/multigroup.vue"
export default component.exports